import type { ZodSchema } from 'zod';
import { z } from 'zod';

import type { MappedConsentType } from '@/components/organisms/RegistrationForm/RegistrationForm.types';

export const RegistrationFormSchema = z.object({
    email: z
        .string()
        .min(1, 'Adres e-mail jest wymagany')
        .regex(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            'Adres e-mail nie jest poprawny',
        ),
    phoneNumber: z
        .string()
        .min(1, 'Numer telefonu jest wymagany')
        .min(9, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)')
        .max(9, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)')
        .regex(/^\d{9}$/, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)'),
    userCode: z
        .string()
        .min(5, 'Kod promocyjny musi zawierać minimum 5 znaków')
        .regex(/^[0-9a-zA-Z_]+$/, 'Kod promocyjny zawiera niedozwolone znaki')
        .optional()
        .or(z.literal('')),
    agreementsAcceptance: z.boolean(),
    captcha: z.string(),
});

export const createValidationSchemaWithConsents = (
    mappedConsents: MappedConsentType[],
) => {
    const dynamicFields = mappedConsents.reduce(
        (schema, { slug, required }) => {
            schema[slug] = required
                ? z.boolean().refine(val => val, {
                      message: 'Akceptacja oświadczenia jest wymagana',
                  })
                : z.boolean();
            return schema;
        },
        {} as { [key in string]: ZodSchema },
    );

    return RegistrationFormSchema.extend(dynamicFields);
};
